import React from 'react';
import { CarouselInfo } from '../components';

const Services = () => {
  return (
    <div className="max-h-full w-full text-white flex flex-col justify-start items-center">
      <div className="bg-black/75 rounded-md text-justify p-5 laptop:w-[65vw] tablet:w-[80vw]">
        <h1 className="text-center text-[#5B9BD5] text-4xl font-bold">
          Services <span className="text-white"> #TheMoon</span>
        </h1>

        <div className="my-6">
          <CarouselInfo />
        </div>
      </div>
    </div>
  )
}

export default Services;